import React from "react"

import { useLocalization } from "@izettle/tenko-react"

import { Modal, ModalType } from "@/core/components/modal"
import { Modals } from "@/modules/sign-up/components/types"

import { PolicyContent } from "./policy-content"

type Props = {
  orgName: string
  phone?: string
  email?: string
  linkToMerchantPrivacyPolicy?: string
}

export function PolicyModal({
  orgName,
  phone,
  email,
  linkToMerchantPrivacyPolicy,
}: Props) {
  const { text } = useLocalization()
  return (
    <Modal
      id={Modals.Policy}
      title={text("SIGNUP_HOW_YOUR_INFORMATION_IS_HANDLED")}
      type={ModalType.Full}
    >
      <PolicyContent
        orgName={orgName}
        phone={phone}
        email={email}
        linkToMerchantPrivacyPolicy={linkToMerchantPrivacyPolicy}
        targetLinks="_blank"
      />
    </Modal>
  )
}
